export default "__VITE_ASSET__B58rtqm5__"